// PurchaseOrderViewItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Input from '../../../common/form/input/input.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import currency from '../../../lib/currency.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import InputPrice from '../../../common/form/input_price/input_price.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class PurchaseOrderViewItem extends Component {
  static get propTypes () {
    return {
      item: PropTypes.object,
      showEdit: PropTypes.bool,
      onClickItem: PropTypes.func,
      onChangeInput: PropTypes.func,
      onBlurInput: PropTypes.func,
      onClickDescription: PropTypes.func,
      onDelete: PropTypes.func,
      itemIdx: PropTypes.number,
      className: PropTypes.string,
      editId: PropTypes.string,
      itemTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }
  }

  static get defaultProps () {
    return {
      item: null,
      showEdit: false,
      onClickItem: null,
      onChangeInput: null,
      onBlurInput: null,
      onClickDescription: null,
      onDelete: null,
      itemIdx: null,
      className: '',
      editId: '',
      itemTotal: 0
    }
  }

  constructor (props) {
    super(props)

    this.data = {
      showExpand: false
    }

    this.state = {
      dataDate: null,
      editable: ''
    }
  }

  render () {
    const bEdit = this.props.showEdit
    const item = this.props.item

    let _className = bEdit ? 'viewitem draft' : 'viewitem'

    if (this.props.editId === item.id) {
      _className = 'viewitem edit'
    }

    return (
      <div className={_className} key={this.props.itemIdx}>
        <div className={this.data.showExpand ? 'colleft expand' : 'colleft'}>
          {this.state.editable === 'title' ? (
            <div className='viewcol colname'>
              <Input
                type='text'
                name='title'
                label='expense.view.labelTitle'
                className='poiteminput'
                value={item.title}
                size={10}
                maxLength={100}
                validations={['required']}
                autoFocus
                onChange={this._onChangeTitle.bind(this, item)}
                onBlur={this._onBlurTitle.bind(this, item)}
              />
            </div>
          ) : (
            <div
              className='viewcol colname'
              onClick={bEdit ? this._onClickItem.bind(this, 'title') : null}
            >
              {item.title || ''}
            </div>
          )}
          <div className='viewcol colproject'>
            {item.project ? item.project.title : ''}
          </div>
          {this.data.showExpand && (
            <div className='viewcol coldesc'>
              <div className='dropcol coltitle typo typo_viewsummary'>
                {this.state.editable === 'description' ? (
                  <div className='label'>
                    <WysiwygEditor
                      placeholder='expense.view.addDescription'
                      value={item.description}
                      onChange={this._onChangeActivityDesc.bind(this, item)}
                      onBlur={this._handleActivityDescBlur.bind(this, item)}
                      autoFocus
                    />
                  </div>
                ) : (
                  <div
                    className='label'
                    onClick={bEdit ? this._onClickDescription.bind(this) : null}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          item.description ||
                          IntlUtil.convertMessage(
                            'expense.view.addDescription'
                          )
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          {!this.data.showExpand && (
            <span
              className='itemaccordion'
              onClick={this._onToggleExpand.bind(this)}
            >
              <i className='icon icon-grid-expand normal' />
            </span>
          )}
          {this.data.showExpand && (
            <span
              className='itemaccordion'
              onClick={this._onToggleExpand.bind(this)}
            >
              <i className='icon icon-planner-accordionclose' />
            </span>
          )}
        </div>
        <div
          className='viewcol colprice'
          onClick={bEdit ? this._onClickItem.bind(this, 'price') : null}
        >
          {this._renderItemPrice(item, bEdit)}
        </div>
      </div>
    )
  }

  _renderItemPrice (item, bEdit) {
    if (bEdit) {
      return (
        <div className='price'>
          {this.state.editable === 'price' ? (
            <InputPrice
              type='text'
              name='price'
              label='expense.view.labelPrice'
              className='purchaseview'
              value={this.props.itemTotal}
              size={10}
              maxLength={100}
              validations={['required']}
              autoFocus
              prefixCurrency={currency.symbol()}
              onChange={this._onChangeTotal.bind(this, item)}
              onBlur={this._onBlurTotal.bind(this)}
            />
          ) : (
            <h2 className='moneyvalue'>
              <span className='value'>
                <PriceText value={item.total} />
              </span>
            </h2>
          )}
          <IconButton
            icon='common-item-delete'
            size='small'
            className='purchaseview'
            onClick={this._onDelete.bind(this, item)}
            canHover={false}
          />
        </div>
      )
    }

    return (
      <div className='price'>
        <h2 className='moneyvalue'>
          <span className='value'>
            <PriceText value={item.total} />
          </span>
        </h2>
      </div>
    )
  }

  /* Event Handlers */
  _onClickItem (name, e) {
    e.preventDefault()

    if (this.props.onClickItem) {
      this.props.onClickItem()
    }

    this.setState({ editable: name })
  }

  _onChangeActivityDesc (item, value) {
    if (this.props.onChangeInput) {
      this.props.onChangeInput(item, value, 'description')
    }
  }

  _handleActivityDescBlur (item, value) {
    this.setState({ editable: '', dataDate: new Date() })

    if (this.props.onBlurInput) {
      this.props.onBlurInput(item, value, 'description')
    }
  }

  _onClickDescription () {
    this.setState({ editable: 'description', dataDate: new Date() })
  }

  _onChangeTitle (item, value) {
    if (this.props.onChangeInput) {
      this.props.onChangeInput(item, value, 'title')
    }
  }

  _onBlurTitle (item) {
    this.setState({ editable: '', dataDate: new Date() })

    if (this.props.onBlurInput) {
      this.props.onBlurInput(item, '', 'title')
    }
  }

  _onChangeTotal (item, value) {
    if (this.props.onChangeInput) {
      this.props.onChangeInput(item, value, 'total')
    }
  }

  _onBlurTotal (e) {
    e.preventDefault()

    this.setState({ editable: '', dataDate: new Date() })

    if (this.props.onBlurInput) {
      this.props.onBlurInput(null, null, 'total')
    }
  }

  _onDelete (delItem) {
    if (this.props.onDelete) {
      this.props.onDelete(delItem)
    }
  }

  _onToggleExpand () {
    this.data.showExpand = !this.data.showExpand
    this.setState({ dataDate: new Date() })
  }
}

export default PurchaseOrderViewItem
